import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faTrash } from '@fortawesome/pro-light-svg-icons'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { confirmDelete } from '@functions/entity'

import copyToClipboard from '@functions/copyToClipboard'

import useIntegration from '@hooks/useIntegration'

const MODAL_KEY = 'ManageUserIntegrationModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const ManageUserIntegrationModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { integration: initIntegration } = modalPayload

  const {
    callbacks: { deleteIntegration: deleteFn },
    updating,
  } = useIntegration(initIntegration)

  const accessToken = digObject(initIntegration, 'access_token', '')

  const confirmDeleteParams = {
    callbacks: {
      afterAction: closeModal,
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This may affect data sync between systems.',
      entityName: 'Integration',
    },
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Access" titleSecondLine="Token" />

      <SidebarModal.Content>
        <Form.Field>
          <textarea
            disabled
            style={{
              height: 500, resize: 'none',
            }}
            value={accessToken}
          />
        </Form.Field>

        <Form.Field label="More Options" marginTop="large">
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faCopy} />}
            onClick={() => copyToClipboard(accessToken)}
            size="medium"
          >
            Copy Token
          </Button>

          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faTrash} />}
            // @ts-expect-error TS2322
            marginTop="medium"
            onClick={() => confirmDelete(confirmDeleteParams)}
            size="medium"
          >
            Delete Integration
          </Button>
        </Form.Field>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryUtility"
          loading={updating}
          onClick={() => closeModal()}
          size="large"
        >
          Close
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManageUserIntegrationModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
